import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=06a4fdb9&scoped=true"
import script from "./Promotion.vue?vue&type=script&lang=ts"
export * from "./Promotion.vue?vue&type=script&lang=ts"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=06a4fdb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a4fdb9",
  null
  
)

export default component.exports